/* src/app/shared/strava-card/strava-card.component.scss */
.stravaCard {
  width: 80vw;
  border-radius: 2vw;
  overflow: hidden;
  box-shadow: 0 0 2px 1px gray;
}
.full {
  border-radius: 5vw;
}
.stravaMap {
  border-left: 1vw solid white;
  border-right: 1vw solid white;
}
.profile-picture {
  background-size: cover;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 100%;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  margin: 0 auto;
  width: 12vw;
  height: 12vw;
  min-width: 12vw;
  overflow: hidden;
}
.profile-picture img {
  width: 12vw;
  height: 12vw;
  border-radius: 100%;
}
.premium {
  position: relative;
  width: 4vw;
  bottom: 0vw;
  left: -3vw;
}
.userSticker {
  padding: 3vw;
}
.stravaKudos {
  min-height: -webkit-fill-available;
  background-color: white;
  padding: 1vw;
  padding-bottom: 2vw;
}
.kudos {
  width: 39vw;
  text-align: left;
  padding: 1vw;
  font-size: small;
}
.comments {
  float: right;
  width: 39vw;
  text-align: right;
  padding: 1vw;
  font-size: small;
}
.kudosandcomments,
.titleLabels {
  display: -webkit-inline-flex;
  width: 100%;
}
.name,
.details {
  padding: 0;
  margin: 0;
}
.details {
  font-size: x-small;
  display: inline-flex;
  align-items: center;
}
.name {
  font-size: medium;
  padding-top: 4vw;
}
.titleName {
  padding-left: 3vw;
  padding-bottom: 0vw;
  padding-top: 1vw;
  font-weight: bold;
}
.titleStats {
  display: -webkit-inline-flex;
  padding-left: 3vw;
  padding-bottom: 2vw;
  padding-right: 3vw;
  width: 100%;
}
.titleSection {
  font-size: x-small;
  width: -webkit-fill-available;
  margin-right: 3vw;
}
.lastTitleSection {
  min-width: 20vw;
  font-size: x-small;
  width: -webkit-fill-available;
  text-align: right;
}
.titleBorder {
  background: gray;
  width: 1vw;
  margin-right: 3vw;
  height: 7vw;
  margin-top: 0.5vw;
  max-height: 7vw;
}
.value {
  font-weight: bold;
  font-size: small;
}
.achievements {
  margin-top: 1vw;
  display: inline-flex;
}
.achImage {
  width: 4vw;
  height: 4vw;
}
.activityIcon {
  max-width: 3vw;
  max-height: 3vw;
}
.dateLocation {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 52vw;
  overflow: hidden;
  margin-left: 1vw;
}
.additional {
  font-size: medium;
  line-height: 12px;
  margin: 1px;
}
/*# sourceMappingURL=strava-card.component.css.map */
